import React, { useState, useEffect, useContext } from "react";
import abiToken from "../abis/bnbabi.json"

import WalletConnectProvider from '@walletconnect/web3-provider';
import { ethers } from 'ethers';
import Private from "./prev1/Private";
const Web3 = require('web3-eth');
const wprovider = new WalletConnectProvider({
    rpc: {
        56: 'https://bsc-dataseed.binance.org/',
    },
    bridge: 'https://bridge.walletconnect.org',
});
const ModalPre = (props) => {

    const [accounts, setAccounts] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [provider, setWCrovider] = useState(wprovider);
    const [errornet, seterrornet] = useState(false);
    const [texterror, seterrormenssage] = useState(<h1 className='errormsg'></h1>);

    function acc() {
        if (accounts != 0) {
            return accounts[0];
        } else {
            return undefined;
        }
    }
    function prove() {
        let prov;
        let wpp = localStorage.getItem('wprovider');
        if (wpp != null) {
            let wp = wpp.split(',');
            if (wp[0] === 'wc') {
                prov = provider;
            } else {
                prov = window.ethereum;
            }
        } else {
            prov = "https://bsc-dataseed.binance.org";

        }
        return prov;
    }
    useEffect(() => {
        let wpp = localStorage.getItem('wprovider');
        if (wpp != null) {
            let wp = wpp.split(',');
            if (wp != null) {
                if (wp[0] === 'wc') {
                    if (wp[1] !== 0) {
                        connecttowalletconnect();
                    }
                } else {
                    if (wp[1] !== 0) {
                        connecttometamask();
                    }
                }
            }
        } else {

        }
    }, []);
    useEffect(() => {
        if (loaded && accounts !== 0) {
            let options = {
                filter: {
                    address: [accounts[0]],
                },
            };
        } else {
            setTimeout(setLoaded(true), 500);
        }

        let wpp = localStorage.getItem('wprovider');
        if (wpp != null) {
            let wp = wpp.split(',');
            if (wp[0] === 'wc') {
                provider.on('disconnect', (code, reason) => {
                    localStorage.removeItem('wprovider');
                    window.location.reload();
                });
            } else {
                if (window.ethereum != null || window.ethereum != undefined)
                    window.ethereum.on('accountsChanged', (accounts) => {
                        if (accounts.length > 0) {
                            setAccounts(accounts)
                        } else {
                            Disconnect();
                        }
                    });
            }
        }
    }, [loaded, accounts]);

    function connectMetaMask() {
        window.web3
            .requestAccounts()
            .then((result) => {
                setAccounts(result);

                const a = result;
                if (loaded && accounts !== 0) {
                    let accounts = localStorage.getItem('wprovider');
                    if (accounts !== null) {
                        let account = accounts.split(',');
                        if (account[1] === a[0]) {
                        } else {
                            window.location.reload();
                        }
                    }
                }
                localStorage.setItem('wprovider', ['mt', a[0]]);
            })
            .catch((error) => {

            });
    }


    function Disconnect() {
        if (localStorage.getItem('wprovider') != null) {
            let wpp = localStorage.getItem('wprovider');
            if (wpp != null) {
                let wp = wpp.split(',');
                if (wp[0] === 'wc') {
                    provider.disconnect()
                } else {

                }
            }
            localStorage.removeItem('wprovider');
            window.location.reload();
        } else {
        }
    }

    function connecttometamask() {
        window.web3 = new Web3(window.ethereum);
        connectMetaMask();
    }
    async function connecttowalletconnect() {
        if (typeof web3 !== 'undefined') {
            //infuraId: "27e484dcd9e3efcfd25a83a78777cdf1",
            provider.on('chainChanged', (chainId) => {
                if (chainId !== 56) {
                    window.location.reload();
                } else {
                    setLoaded(true);
                }
            });
            await provider
                .enable()
                .then(() => {
                    const web3 = new Web3(provider);
                    window.web3 = web3;
                    setAccounts([provider.accounts[0]]);
                    const a = provider.accounts[0];
                    if (loaded && accounts !== 0) {
                        let accounts = localStorage.getItem('wprovider');
                        if (accounts != null) {
                            let account = accounts.split(',');
                            if (account[1] === a) {
                            } else {
                                window.location.reload();
                            }
                        }
                    }
                    localStorage.setItem('wprovider', ['wc', a]);
                })
                .catch((error) => {

                    setWCrovider(
                        new WalletConnectProvider({
                            rpc: {
                                56: 'https://bsc-dataseed.binance.org/',
                            },
                            bridge: 'https://bridge.walletconnect.org',
                        })
                    );
                });
        } else {
            provider.on('chainChanged', (chainId) => {
                if (chainId !== 56) {
                    window.location.reload();
                } else {
                    setLoaded(true);
                }
            });
            await provider
                .enable()
                .then(() => {
                    const web3 = new Web3(provider);
                    window.web3 = web3;
                    setAccounts([provider.accounts[0]]);
                    const a = provider.accounts[0];
                    if (loaded && accounts !== 0) {
                        let accounts = localStorage.getItem('wprovider');
                        if (accounts != null) {
                            let account = accounts.split(',');
                            if (account[1] === a) {
                            } else {
                                window.location.reload();
                            }
                        }
                    }
                    localStorage.setItem('wprovider', ['wc', a]);
                })
                .catch((err) => {
                    console.log('Error when connecting via walletConnect');
                    console.log(err);
                    setWCrovider(
                        new WalletConnectProvider({
                            rpc: {
                                56: 'https://bsc-dataseed.binance.org/',
                            },
                            bridge: 'https://bridge.walletconnect.org',
                        })
                    );
                });
        }
    }
    const buttoconect = () => {
        let text = null;
        if (loaded && (accounts !== 0)) {
            // get user info
            text = accounts[0];
            text = text.slice(0, 4) + '...' + text.slice(-4);
        } else {
            text = "Connect";
        }
        return text;
    }

    const [list, setList] = useState([]);
    const [poofee, setpoofee] = useState(0);
    useEffect(() => {

    }, []);
    async function Tokencontract(abi, address) {
        const web3 = new Web3(prove());
        return new web3.Contract(abi, address);
    }
    function getQuery(query) {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get(query);
        return foo
    }

    const colorData = {
        background: getQuery('bg') == null ? '#000000' : '#' + getQuery('bg'),
        fontColor: getQuery('fontcolor') == null ? '#ffffff' : '#' + getQuery('fontcolor'),
        iColor: getQuery('icolor') == null ? '#999999' : '#' + getQuery('icolor')
    }

    const nSendTX = async (_contract, _abi, _id, _func, _value, gwei, ...args) => {
        const contract = await Tokencontract(_abi, _contract)
        const gas = await contract.methods[_func](...args).estimateGas({ from: acc(), value: _value })
        contract.methods[_func](...args)
            .send({
                from: acc(),
                gas: gas,
                value: _value,
            })
            .then((res) => {

            })
            .catch((err) => {

            });

    };

    function nextblock(accountBalancemctTB, d) {
        return parseFloat(ethers.utils.formatUnits(accountBalancemctTB, d)).toFixed(8)
    }


    let stakeColumns = <div style={{ width: "100%", display: "grid", minHeight: "480px" }}>
        <div className='borderfull' style={{
            height: "min-content",
            width: "100%",
            display: "grid",
            maxWidth: "360px",
            gap: "10px",
            borderRadius: "10px",
            marginTop: "auto",
            margin: "auto",
            color: "#fff",
            padding: "2px 5px"
        }}>

            <div style={{
                height: "45px",
                width: "95%",
                color: "#fff",
                margin: "auto",
                display: "grid",
                gridTemplateColumns: "40px auto 40px",

            }}>
                <div style={{
                    height: "40px",
                    width: "40px",
                    color: "#fff",
                    margin: "auto",
                    background: "url(" + "https://bscscan.com/token/images/binance_32.png" + ")",
                    backgroundSize: "70%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    display: "grid",
                    borderRadius: "360px",
                }}>

                </div >
                <input style={{
                    height: "35px",
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                    background: "#00000000",
                    color: "#fff",
                    border: "1px solid #ffffff40",
                    borderRadius: "5px",
                    outline: "none"
                }} />
                <div style={{
                    height: "min-content",
                    width: "40px",
                    margin: "auto",
                    cursor: "pointer"
                }}>
                    MAX
                </div>
            </div>
        </div>

    </div>


    return (
        <>
            <Private acc={acc()} p={prove()}
                Disconnect={Disconnect}
                connecttometamask={connecttometamask}

                connecttowalletconnect={connecttowalletconnect} buttoconect={buttoconect} />
        </>
    );
}

export default ModalPre;